import DashboardsPlaceholder from './DashboardsPlaceholder';

export default DashboardsPlaceholder;
